import { useCallback, useMemo, useState } from 'react';
import { DEFAULT_LOCALE, getTranslations, isRtlLocale, translations } from '../i18n';

const LOCALE_STORAGE_KEY = 'playhouse.locale';

const loadLocale = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_LOCALE;
  }

  const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY);
  if (!stored) {
    return DEFAULT_LOCALE;
  }

  return stored;
};

const persistLocale = (locale) => {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
};

export const useLocale = () => {
  const [locale, setLocaleState] = useState(() => loadLocale());

  const setLocale = useCallback((nextLocale) => {
    setLocaleState(nextLocale);
    persistLocale(nextLocale);
  }, []);

  const dictionary = useMemo(() => getTranslations(locale), [locale]);
  const isRtl = useMemo(() => isRtlLocale(locale), [locale]);

  const t = useCallback(
    (key) => dictionary[key] ?? translations.en[key] ?? key,
    [dictionary],
  );

  return { locale, setLocale, t, isRtl };
};
